import type { PlateElementProps } from 'platejs/react';
import React from 'react';

import { cx } from '@/utils/cx';

import type { PlateSlotNode } from './plateEmailSerializer';

export const SlotElement: React.FC<PlateElementProps> = ({
  attributes,
  children,
  element,
}) => {
  const node = element as unknown as PlateSlotNode;

  const isUnableToLoad = Boolean(node.resolutionFailed) && !node.label;
  const isPending = !isUnableToLoad && !node.label;

  let label = `${node.label ?? ''}`;
  let textColorClass = 'text-[var(--color-text-primary)]';
  if (isUnableToLoad) {
    label = 'Unable to load time';
    textColorClass = 'text-[var(--color-text-error-primary)]';
  } else if (isPending) {
    label = '…';
    textColorClass = 'text-[var(--color-text-tertiary)]';
  }

  // The visible label sits in an inner `contentEditable={false}` span so it
  // can't be edited directly, while Slate's zero-width text `children` node
  // stays outside that span, inside the outer editable `attributes` span.
  // This mirrors @platejs/mention's element structure and works around a
  // Chromium bug where the caret can't be placed beside a zero-width inline
  // void when the void's only child is itself non-editable.
  return (
    <span {...attributes} className='inline-flex align-middle'>
      <span
        contentEditable={false}
        className={cx(
          'border-b border-dotted border-[var(--color-border-primary)]',
          textColorClass
        )}
      >
        {label}
      </span>
      {children}
    </span>
  );
};

export default SlotElement;
